import { colorDuxtonBlue, colorPrimary, colorSuccess, colorWarning, colorError, colorInfo, colorLink, colorOrange, colorWhite, colorTeal, fontFamily } from '@duxton-web/design-tokens';
import { colorStatusNeutralSoft, colorStatusNeutralDefault, colorStatusPositiveBoldest } from '@duxton-web/design-tokens/themes/light';
export const defaultPresetColors = {
  blue: colorInfo,
  purple: '#722ED1',
  // Dui: deprecating
  cyan: colorTeal,
  // Dui: deprecating
  green: colorPrimary,
  magenta: '#EB2F96',
  // Dui: deprecating
  pink: '#eb2f96',
  // Dui: deprecating
  red: colorError,
  orange: colorOrange,
  yellow: colorWarning,
  volcano: '#FA541C',
  // Dui: deprecating
  geekblue: colorDuxtonBlue,
  // Dui: deprecating
  gold: '#FAAD14',
  // Dui: deprecating
  lime: '#A0D911',
  // Dui: deprecating
  white: colorWhite,
  // Dui
  grey: colorStatusNeutralSoft,
  // Dui
  darkgreen: colorStatusPositiveBoldest,
  // Dui
  teal: colorTeal // Dui
};
const seedToken = Object.assign(Object.assign({}, defaultPresetColors), {
  // Color
  // Dui start
  colorPrimary,
  colorSuccess,
  colorWarning,
  colorError,
  colorInfo,
  colorLink,
  colorNeutral: colorStatusNeutralDefault,
  // Dui end
  colorTextBase: '',
  colorBgBase: '',
  // Font
  // Dui start
  fontFamily,
  fontFamilyCode: ``,
  // Dui end
  fontSize: 14,
  // Line
  lineWidth: 1,
  lineType: 'solid',
  // Motion
  motionUnit: 0.1,
  motionBase: 0,
  motionEaseOutCirc: 'cubic-bezier(0.08, 0.82, 0.17, 1)',
  motionEaseInOutCirc: 'cubic-bezier(0.78, 0.14, 0.15, 0.86)',
  motionEaseOut: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
  motionEaseInOut: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
  motionEaseOutBack: 'cubic-bezier(0.12, 0.4, 0.29, 1.46)',
  motionEaseInBack: 'cubic-bezier(0.71, -0.46, 0.88, 0.6)',
  motionEaseInQuint: 'cubic-bezier(0.755, 0.05, 0.855, 0.06)',
  motionEaseOutQuint: 'cubic-bezier(0.23, 1, 0.32, 1)',
  // Radius
  borderRadius: 12,
  // Size
  sizeUnit: 4,
  sizeStep: 4,
  sizePopupArrow: 16,
  // Control Base
  controlHeight: 40,
  // zIndex
  zIndexBase: 0,
  zIndexPopupBase: 1000,
  // Image
  opacityImage: 1,
  // Wireframe
  wireframe: false,
  // Motion
  motion: true
});
export default seedToken;